export const ERROR_NOTIFICATION = 'ERROR_NOTIFICATION';
